import React from "react";
import me from "../assets/img/me.png";
import reacticon from "../assets/img/reacticon.png";
import js from "../assets/img/js.png";
import css from "../assets/img/css.png";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        {/* Contenedor del texto */}
        <div className="about-text">
          <h2>Sobre Mí</h2>
          <p>
            Ingeniero de Sistemas, desarrollador web, diseñador web y
            especialista en diseño UI/UX. Cuento con un diplomado en diseño
            UX/UI, así como experiencia en edición de video y en la realización
            de pruebas de automatización utilizando Playwright. Me considero una
            persona apasionada por los retos y comprometida con salir de mi zona
            de confort. Disfruto aprendiendo nuevas habilidades y expandiendo
            mis conocimientos constantemente. También poseo conocimientos
            básicos en Flutter y Android Studio, lo que me permite abordar
            proyectos móviles de manera inicial. Mi nivel intermedio en la suite
            de Adobe incluye herramientas como After Effects, Adobe Premiere
            Pro, Adobe XD, Adobe Illustrator y Adobe Photoshop. Además, tengo un
            dominio avanzado de Figma, lo que me permite crear diseños digitales
            innovadores y funcionales. Estoy siempre en búsqueda de proyectos
            que desafíen mi creatividad y habilidades técnicas, contribuyendo al
            desarrollo de soluciones efectivas y estéticamente atractivas.
          </p>
        </div>

        {/* Contenedor de la imagen y los íconos */}
        <div className="about-image-container">
          <img
            src={me} /* Reemplaza con la URL de tu imagen */
            alt="Cristian Extiven Valencia Pino"
            className="about-image"
          />
          <div className="tech-icons">
            {/* <img src={reacticon} alt="React.js" className="icon" />
            <img src={js} alt="JavaScript" className="icon" />
            <img src={css} alt="CSS" className="icon" /> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
